import styled from "styled-components";
import {fontFamilies} from "theme/tokens";

/**
 * Externalized styles for {@link ./KeepTabOpenDialog}, the keep-this-tab-open notice over a direct transfer's live
 * card (kitecorp/transferify-ui#3724). Token-driven, so light and dark follow the theme; the paper, the title's
 * place and the body's padding are `BaseDialog`'s and `ClosableDialog.styles.DialogBody`'s.
 */

/** The browser-tab glyph on the title's own line, the glyph first (owner-approved prototype). */
export const TitleRow = styled.span`
	display: flex;
	align-items: center;
	gap: 12px;
	min-width: 0;
`;

/**
 * The glyph's tile, in the amber warning family the send screen's download-limit card wears: a flat pale surface,
 * its edge and its ink, each per mode, so the tile inverts with the theme.
 */
export const IconTile = styled.span`
	flex: none;
	display: grid;
	place-items: center;
	width: 44px;
	height: 44px;
	box-sizing: border-box;
	border-radius: 12px;
	border: 1px solid ${({theme}) => theme.tokens.amberEdge};
	background: ${({theme}) => theme.tokens.amberSurface};
	color: ${({theme}) => theme.tokens.amberInk};
`;

export const TitleText = styled.span`
	min-width: 0;
	font: 700 20px/1.25 ${fontFamilies.sans};
	letter-spacing: -0.01em;
	color: ${({theme}) => theme.tokens.ink};
	text-wrap: balance;
`;

export const BodyText = styled.p`
	margin: 0;
	font-size: 15px;
	line-height: 1.5;
	color: ${({theme}) => theme.tokens.ink2};
`;

/**
 * The box on the left and the button on the right, on one line where both fit; on a phone the box above a
 * full-width button, as the prototype draws it at 375 px.
 */
export const Actions = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: space-between;
	gap: 8px 16px;
	margin-top: 18px;

	@media (max-width: 480px) {
		flex-direction: column;
		align-items: stretch;
	}
`;

/**
 * The box and its label on one row, the whole row the hit target, at the body's secondary weight so it reads as an
 * option and not as a second action. At least the 40px a compact control stands, so a thumb finds it beside the
 * button.
 */
export const DontShowAgain = styled.label`
	display: inline-flex;
	align-items: center;
	gap: 10px;
	min-height: 40px;
	font-size: 14px;
	line-height: 1.4;
	color: ${({theme}) => theme.tokens.ink2};
	cursor: pointer;
`;

/** The box itself, in the brand blue the app's other native boxes wear (`marketing/MarketingObjection.styles`). */
export const DontShowAgainBox = styled.input`
	flex: none;
	width: 18px;
	height: 18px;
	margin: 0;
	accent-color: ${({theme}) => theme.tokens.blue};
	cursor: pointer;
`;
